import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()

    this.connectAppsOnSwupTransition()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  connectAppsOnSwupTransition() {
    if (typeof window.yotpo?.initWidgets === 'function') {
      window.yotpo?.initWidgets()
    }

    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      window.yotpoWidgetsContainer?.initWidgets()
    }
  }


  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  deepSet(obj, path, value) {
    if (Object(obj) !== obj) return obj
    if (!Array.isArray(path)) path = path.toString().match(/[^.[\]]+/g) || []
    path
      .slice(0, -1)
      .reduce(
        (a, c, i) =>
          Object(a[c]) === a[c]
            ? a[c]
            : (a[c] = Math.abs(path[i + 1]) >> 0 === +path[i + 1] ? [] : {}),
        obj
      )[path[path.length - 1]] = value
    return obj
  }

  formDataObject(form) {
    const formData = new FormData(form)
    const root = {}
    for (const [path, value] of formData) {
      this.deepSet(root, path, value)
    }
    return root
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    const data = await addToCart(this.formDataObject(this.form))

    reRenderShopifySections(data)

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'cart-notification',
        },
      })
    )

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  get submitButton() {
    return this.querySelector('[type="submit"]') ?? null
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
